import React, { useContext } from 'react';
import { SEAT_CIRCLE_RADIUS } from '../../constants';
import { ComponentContext } from '../../contexts';
import { DH } from '../../data-hooks';
import { CurvedRow } from '../curved-row';
import { generateCurvedRowPath } from '../../utils/geometry';
import { useCurvedMultiRow } from './use-curved-multi-row';
export const CurvedMultiRow = (props) => {
    const { definition: { width, height, angle }, } = props;
    const { rows } = useCurvedMultiRow(props);
    const { PointerArea, PointerPath } = useContext(ComponentContext);
    return (React.createElement(React.Fragment, null,
        rows.map(rowDefinition => (React.createElement("svg", { key: rowDefinition.id, x: 0, y: rowDefinition.midY - SEAT_CIRCLE_RADIUS, "data-hook": DH.MULTI_ROW_ROW },
            React.createElement(CurvedRow, { definition: rowDefinition, key: rowDefinition.id, realAngle: angle, rowDataHook: DH.MULTI_ROW_ROW_SEATS }),
            React.createElement(PointerPath, { d: generateCurvedRowPath({ ...rowDefinition, midY: SEAT_CIRCLE_RADIUS }), "data-element-id": rowDefinition.id })))),
        React.createElement(PointerArea, { width: width, height: height })));
};
//# sourceMappingURL=curved-multi-row.js.map